module.exports = __webpack_public_path__ + "components/rewards/christy/static/logo-5d188f79aec417cc7da502cc9f35574f.jpg";